// Countries preset for choice fields (Jordan first, then Arabic alphabetical) — same list the default form uses.
// [ISO code, Arabic, English]
export const COUNTRIES: [string, string, string][] = [
  ['JO', "الأردن", "Jordan"],
  ['IS', "آيسلندا", "Iceland"],
  ['ET', "إثيوبيا", "Ethiopia"],
  ['AZ', "أذربيجان", "Azerbaijan"],
  ['AM', "أرمينيا", "Armenia"],
  ['AW', "أروبا", "Aruba"],
  ['ER', "إريتريا", "Eritrea"],
  ['ES', "إسبانيا", "Spain"],
  ['AU', "أستراليا", "Australia"],
  ['EE', "إستونيا", "Estonia"],
  ['IL', "إسرائيل", "Israel"],
  ['SZ', "إسواتيني", "Eswatini"],
  ['AF', "أفغانستان", "Afghanistan"],
  ['AR', "الأرجنتين", "Argentina"],
  ['EC', "الإكوادور", "Ecuador"],
  ['AE', "الإمارات العربية المتحدة", "United Arab Emirates"],
  ['AL', "ألبانيا", "Albania"],
  ['BH', "البحرين", "Bahrain"],
  ['BR', "البرازيل", "Brazil"],
  ['PT', "البرتغال", "Portugal"],
  ['BA', "البوسنة والهرسك", "Bosnia & Herzegovina"],
  ['CZ', "التشيك", "Czechia"],
  ['ME', "الجبل الأسود", "Montenegro"],
  ['DZ', "الجزائر", "Algeria"],
  ['DK', "الدانمرك", "Denmark"],
  ['CV', "الرأس الأخضر", "Cape Verde"],
  ['SV', "السلفادور", "El Salvador"],
  ['SN', "السنغال", "Senegal"],
  ['SD', "السودان", "Sudan"],
  ['SE', "السويد", "Sweden"],
  ['EH', "الصحراء الغربية", "Western Sahara"],
  ['SO', "الصومال", "Somalia"],
  ['CN', "الصين", "China"],
  ['IQ', "العراق", "Iraq"],
  ['GA', "الغابون", "Gabon"],
  ['VA', "الفاتيكان", "Vatican City"],
  ['PH', "الفلبين", "Philippines"],
  ['CM', "الكاميرون", "Cameroon"],
  ['CG', "الكونغو - برازافيل", "Congo - Brazzaville"],
  ['CD', "الكونغو - كينشاسا", "Congo - Kinshasa"],
  ['KW', "الكويت", "Kuwait"],
  ['DE', "ألمانيا", "Germany"],
  ['MA', "المغرب", "Morocco"],
  ['MX', "المكسيك", "Mexico"],
  ['SA', "المملكة العربية السعودية", "Saudi Arabia"],
  ['GB', "المملكة المتحدة", "United Kingdom"],
  ['NO', "النرويج", "Norway"],
  ['AT', "النمسا", "Austria"],
  ['NE', "النيجر", "Niger"],
  ['IN', "الهند", "India"],
  ['US', "الولايات المتحدة", "United States"],
  ['JP', "اليابان", "Japan"],
  ['YE', "اليمن", "Yemen"],
  ['GR', "اليونان", "Greece"],
  ['AG', "أنتيغوا وبربودا", "Antigua & Barbuda"],
  ['AD', "أندورا", "Andorra"],
  ['ID', "إندونيسيا", "Indonesia"],
  ['AO', "أنغولا", "Angola"],
  ['AI', "أنغويلا", "Anguilla"],
  ['UY', "أورغواي", "Uruguay"],
  ['UZ', "أوزبكستان", "Uzbekistan"],
  ['UG', "أوغندا", "Uganda"],
  ['UA', "أوكرانيا", "Ukraine"],
  ['IR', "إيران", "Iran"],
  ['IE', "أيرلندا", "Ireland"],
  ['IT', "إيطاليا", "Italy"],
  ['PG', "بابوا غينيا الجديدة", "Papua New Guinea"],
  ['PY', "باراغواي", "Paraguay"],
  ['PK', "باكستان", "Pakistan"],
  ['PW', "بالاو", "Palau"],
  ['BB', "بربادوس", "Barbados"],
  ['BM', "برمودا", "Bermuda"],
  ['BN', "بروناي", "Brunei"],
  ['BE', "بلجيكا", "Belgium"],
  ['BG', "بلغاريا", "Bulgaria"],
  ['BZ', "بليز", "Belize"],
  ['BD', "بنغلاديش", "Bangladesh"],
  ['PA', "بنما", "Panama"],
  ['BJ', "بنين", "Benin"],
  ['BT', "بوتان", "Bhutan"],
  ['BW', "بوتسوانا", "Botswana"],
  ['PR', "بورتوريكو", "Puerto Rico"],
  ['BF', "بوركينا فاسو", "Burkina Faso"],
  ['BI', "بوروندي", "Burundi"],
  ['PL', "بولندا", "Poland"],
  ['BO', "بوليفيا", "Bolivia"],
  ['PF', "بولينيزيا الفرنسية", "French Polynesia"],
  ['PE', "بيرو", "Peru"],
  ['BY', "بيلاروس", "Belarus"],
  ['TH', "تايلاند", "Thailand"],
  ['TW', "تايوان", "Taiwan"],
  ['TM', "تركمانستان", "Turkmenistan"],
  ['TR', "تركيا", "T\u00fcrkiye"],
  ['TT', "ترينيداد وتوباغو", "Trinidad & Tobago"],
  ['TD', "تشاد", "Chad"],
  ['CL', "تشيلي", "Chile"],
  ['TZ', "تنزانيا", "Tanzania"],
  ['TG', "توغو", "Togo"],
  ['TV', "توفالو", "Tuvalu"],
  ['TK', "توكيلاو", "Tokelau"],
  ['TN', "تونس", "Tunisia"],
  ['TO', "تونغا", "Tonga"],
  ['TL', "تيمور - ليشتي", "Timor-Leste"],
  ['JM', "جامايكا", "Jamaica"],
  ['GI', "جبل طارق", "Gibraltar"],
  ['AX', "جزر آلاند", "\u00c5land Islands"],
  ['BS', "جزر البهاما", "Bahamas"],
  ['KM', "جزر القمر", "Comoros"],
  ['MQ', "جزر المارتينيك", "Martinique"],
  ['MV', "جزر المالديف", "Maldives"],
  ['PN', "جزر بيتكيرن", "Pitcairn Islands"],
  ['TC', "جزر توركس وكايكوس", "Turks & Caicos Islands"],
  ['SB', "جزر سليمان", "Solomon Islands"],
  ['FO', "جزر فارو", "Faroe Islands"],
  ['FK', "جزر فوكلاند", "Falkland Islands"],
  ['VI', "جزر فيرجن الأمريكية", "U.S. Virgin Islands"],
  ['VG', "جزر فيرجن البريطانية", "British Virgin Islands"],
  ['KY', "جزر كايمان", "Cayman Islands"],
  ['CK', "جزر كوك", "Cook Islands"],
  ['CC', "جزر كوكوس (كيلينغ)", "Cocos (Keeling) Islands"],
  ['MH', "جزر مارشال", "Marshall Islands"],
  ['MP', "جزر ماريانا الشمالية", "Northern Mariana Islands"],
  ['WF', "جزر والس وفوتونا", "Wallis & Futuna"],
  ['CX', "جزيرة كريسماس", "Christmas Island"],
  ['IM', "جزيرة مان", "Isle of Man"],
  ['NF', "جزيرة نورفولك", "Norfolk Island"],
  ['CF', "جمهورية أفريقيا الوسطى", "Central African Republic"],
  ['DO', "جمهورية الدومينيكان", "Dominican Republic"],
  ['ZA', "جنوب أفريقيا", "South Africa"],
  ['SS', "جنوب السودان", "South Sudan"],
  ['GE', "جورجيا", "Georgia"],
  ['DJ', "جيبوتي", "Djibouti"],
  ['JE', "جيرسي", "Jersey"],
  ['DM', "دومينيكا", "Dominica"],
  ['RW', "رواندا", "Rwanda"],
  ['RU', "روسيا", "Russia"],
  ['RO', "رومانيا", "Romania"],
  ['RE', "روينيون", "R\u00e9union"],
  ['ZM', "زامبيا", "Zambia"],
  ['ZW', "زيمبابوي", "Zimbabwe"],
  ['CI', "ساحل العاج", "C\u00f4te d\u2019Ivoire"],
  ['WS', "ساموا", "Samoa"],
  ['AS', "ساموا الأمريكية", "American Samoa"],
  ['BL', "سان بارتليمي", "St. Barth\u00e9lemy"],
  ['PM', "سان بيير ومكويلون", "St. Pierre & Miquelon"],
  ['MF', "سان مارتن", "St. Martin"],
  ['SM', "سان مارينو", "San Marino"],
  ['VC', "سانت فنسنت وجزر غرينادين", "St. Vincent & Grenadines"],
  ['KN', "سانت كيتس ونيفيس", "St. Kitts & Nevis"],
  ['LC', "سانت لوسيا", "St. Lucia"],
  ['SX', "سانت مارتن", "Sint Maarten"],
  ['SH', "سانت هيلينا", "St. Helena"],
  ['ST', "ساو تومي وبرينسيبي", "S\u00e3o Tom\u00e9 & Pr\u00edncipe"],
  ['LK', "سريلانكا", "Sri Lanka"],
  ['SJ', "سفالبارد وجان ماين", "Svalbard & Jan Mayen"],
  ['SK', "سلوفاكيا", "Slovakia"],
  ['SI', "سلوفينيا", "Slovenia"],
  ['SG', "سنغافورة", "Singapore"],
  ['SY', "سوريا", "Syria"],
  ['SR', "سورينام", "Suriname"],
  ['CH', "سويسرا", "Switzerland"],
  ['SL', "سيراليون", "Sierra Leone"],
  ['SC', "سيشل", "Seychelles"],
  ['RS', "صربيا", "Serbia"],
  ['TJ', "طاجيكستان", "Tajikistan"],
  ['OM', "عُمان", "Oman"],
  ['GM', "غامبيا", "Gambia"],
  ['GH', "غانا", "Ghana"],
  ['GD', "غرينادا", "Grenada"],
  ['GL', "غرينلاند", "Greenland"],
  ['GT', "غواتيمالا", "Guatemala"],
  ['GP', "غوادلوب", "Guadeloupe"],
  ['GU', "غوام", "Guam"],
  ['GF', "غويانا الفرنسية", "French Guiana"],
  ['GY', "غيانا", "Guyana"],
  ['GG', "غيرنزي", "Guernsey"],
  ['GN', "غينيا", "Guinea"],
  ['GQ', "غينيا الاستوائية", "Equatorial Guinea"],
  ['GW', "غينيا بيساو", "Guinea-Bissau"],
  ['VU', "فانواتو", "Vanuatu"],
  ['FR', "فرنسا", "France"],
  ['PS', "فلسطين", "Palestine"],
  ['VE', "فنزويلا", "Venezuela"],
  ['FI', "فنلندا", "Finland"],
  ['VN', "فيتنام", "Vietnam"],
  ['FJ', "فيجي", "Fiji"],
  ['CY', "قبرص", "Cyprus"],
  ['QA', "قطر", "Qatar"],
  ['KG', "قيرغيزستان", "Kyrgyzstan"],
  ['KZ', "كازاخستان", "Kazakhstan"],
  ['NC', "كاليدونيا الجديدة", "New Caledonia"],
  ['HR', "كرواتيا", "Croatia"],
  ['KH', "كمبوديا", "Cambodia"],
  ['CA', "كندا", "Canada"],
  ['CU', "كوبا", "Cuba"],
  ['CW', "كوراساو", "Cura\u00e7ao"],
  ['KR', "كوريا الجنوبية", "South Korea"],
  ['KP', "كوريا الشمالية", "North Korea"],
  ['CR', "كوستاريكا", "Costa Rica"],
  ['CO', "كولومبيا", "Colombia"],
  ['KI', "كيريباتي", "Kiribati"],
  ['KE', "كينيا", "Kenya"],
  ['LV', "لاتفيا", "Latvia"],
  ['LA', "لاوس", "Laos"],
  ['LB', "لبنان", "Lebanon"],
  ['LU', "لوكسمبورغ", "Luxembourg"],
  ['LY', "ليبيا", "Libya"],
  ['LR', "ليبيريا", "Liberia"],
  ['LT', "ليتوانيا", "Lithuania"],
  ['LI', "ليختنشتاين", "Liechtenstein"],
  ['LS', "ليسوتو", "Lesotho"],
  ['MO', "ماكاو", "Macao"],
  ['MT', "مالطا", "Malta"],
  ['ML', "مالي", "Mali"],
  ['MY', "ماليزيا", "Malaysia"],
  ['YT', "مايوت", "Mayotte"],
  ['MG', "مدغشقر", "Madagascar"],
  ['EG', "مصر", "Egypt"],
  ['MK', "مقدونيا الشمالية", "North Macedonia"],
  ['MW', "ملاوي", "Malawi"],
  ['MN', "منغوليا", "Mongolia"],
  ['MR', "موريتانيا", "Mauritania"],
  ['MU', "موريشيوس", "Mauritius"],
  ['MZ', "موزمبيق", "Mozambique"],
  ['MD', "مولدوفا", "Moldova"],
  ['MC', "موناكو", "Monaco"],
  ['MS', "مونتسرات", "Montserrat"],
  ['MM', "ميانمار (بورما)", "Myanmar (Burma)"],
  ['FM', "ميكرونيزيا", "Micronesia"],
  ['NA', "ناميبيا", "Namibia"],
  ['NR', "ناورو", "Nauru"],
  ['NP', "نيبال", "Nepal"],
  ['NG', "نيجيريا", "Nigeria"],
  ['NI', "نيكاراغوا", "Nicaragua"],
  ['NZ', "نيوزيلندا", "New Zealand"],
  ['NU', "نيوي", "Niue"],
  ['HT', "هايتي", "Haiti"],
  ['HN', "هندوراس", "Honduras"],
  ['HU', "هنغاريا", "Hungary"],
  ['NL', "هولندا", "Netherlands"],
  ['BQ', "هولندا الكاريبية", "Caribbean Netherlands"],
  ['HK', "هونغ كونغ", "Hong Kong"],
];
